import { render, staticRenderFns } from "./CadastroTerritorioAr.vue?vue&type=template&id=19741207&scoped=true&lang=pug"
import script from "./CadastroTerritorioAr.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioAr.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorioAr.vue?vue&type=style&index=0&id=19741207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19741207",
  null
  
)

export default component.exports